import IsNullOrUndefined from "./ObjectUtils";

const ToBoolean = (variable) => {
    if (IsNullOrUndefined(variable)) return false;

    return variable.toLowerCase() === "true";
};

export default ToBoolean;
